export interface Category {
  slug: string;
  name: string;
  icon: string;
  desc: string;
  color: 'primary' | 'accent' | 'secondary';
}

export interface FeedItem {
  id: number;
  title: string;
  excerpt: string;
  author: string;
  authorAvatar: string;
  time: string;
  views: string;
  likes: number;
  comments: number;
  category: string;
  hot: boolean;
}

export interface HotItem {
  rank: number;
  title: string;
  heat: string;
  tag: string;
  up: boolean;
}

export interface GuideItem {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const categories: Category[] = [
  { slug: 'yule', name: '娱乐新瓜', icon: 'ri-mic-2-fill', desc: '娱乐圈新鲜事、热剧综艺一手速递', color: 'primary' },
  { slug: 'reju', name: '热剧追更', icon: 'ri-tv-2-fill', desc: '本周热播剧集中剧透与观后唠嗑', color: 'accent' },
  { slug: 'zongyi', name: '综艺名场面', icon: 'ri-emotion-laugh-fill', desc: '综艺里那些值得反复回看的高光', color: 'secondary' },
  { slug: 'yinyue', name: '音乐现场', icon: 'ri-music-2-fill', desc: '新歌首发、音乐节与舞台高能时刻', color: 'primary' },
  { slug: 'shenghuo', name: '生活唠嗑', icon: 'ri-chat-smile-3-fill', desc: '身边事、社会话题与你的碎碎念', color: 'accent' },
  { slug: 'chongwu', name: '萌宠日常', icon: 'ri-heart-fill', desc: '毛孩子们的搞笑瞬间与暖心日常', color: 'secondary' },
];

export const categoryFilter: string[] = ['全部', '娱乐新瓜', '热剧追更', '综艺名场面', '音乐现场', '生活唠嗑', '萌宠日常'];

export const hotList: HotItem[] = [
  { rank: 1, title: '热播剧大结局冲上热搜，网友直呼反转太狠', heat: '286万', tag: '讨论中', up: true },
  { rank: 2, title: '老牌综艺回归首播，弹幕一秒破万', heat: '241万', tag: '新开播', up: true },
  { rank: 3, title: '顶流歌手新单曲上线，评论区被现场炸了', heat: '198万', tag: '爆', up: true },
  { rank: 4, title: '直播带货翻车名场面盘点，瓜友笑不活了', heat: '167万', tag: '热议', up: true },
  { rank: 5, title: '一夜爆红的网络热梗，原来是这么来的', heat: '142万', tag: '涨', up: true },
  { rank: 6, title: '新片首映礼路透流出，阵容有点东西', heat: '121万', tag: '新瓜', up: false },
  { rank: 7, title: '明星工作室深夜声明，吃瓜群众蹲后续', heat: '98万', tag: '进行中', up: true },
];

export const feedItems: FeedItem[] = [
  {
    id: 1,
    title: '大结局里那个埋了十集的伏笔，原来早就有暗示！',
    excerpt: '熬夜追完结局，越想越上头。回看前面几集才发现伏笔处处都是，导演的草蛇灰线藏得也太深了，忍不住来唠一唠我的推断。',
    author: '追剧小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20young%20woman%20with%20deer%20ears%2C%20soft%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-lu&orientation=squarish',
    time: '12分钟前',
    views: '1.2万',
    likes: 2314,
    comments: 486,
    category: '热剧追更',
    hot: true,
  },
  {
    id: 2,
    title: '新综艺首期这段即兴发挥，把在场所有人都逗笑了',
    excerpt: '本来冲着嘉宾阵容去的，结果被现场一个完全没准备的即兴互动圈粉。弹幕和现场观众集体笑出画外音，这期可以封神了。',
    author: '笑点很低',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20smiling%20boy%20with%20round%20glasses%2C%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-xiao&orientation=squarish',
    time: '38分钟前',
    views: '9360',
    likes: 1678,
    comments: 322,
    category: '综艺名场面',
    hot: true,
  },
  {
    id: 3,
    title: '这首歌的现场版比录音室还带感，循环一下午了',
    excerpt: '现场版的编曲加入了弦乐和人声和声，比专辑多了好多层次。安可那段灯光一起，鸡皮疙瘩都起来了，必须安利给瓜友。',
    author: '耳机分你一半',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20music%20lover%20with%20headphones%2C%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-erji&orientation=squarish',
    time: '1小时前',
    views: '7820',
    likes: 1204,
    comments: 198,
    category: '音乐现场',
    hot: false,
  },
  {
    id: 4,
    title: '下班路上看到这一幕，莫名被治愈到了',
    excerpt: '今天加班到八点半，回家路上看到小区门口有只猫正趴在快递柜上晒太阳，瞬间觉得这一天的疲惫都值了，分享给瓜友们。',
    author: '下班路上',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20cat%20with%20a%20bag%2C%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-mao&orientation=squarish',
    time: '2小时前',
    views: '5130',
    likes: 987,
    comments: 154,
    category: '生活唠嗑',
    hot: false,
  },
  {
    id: 5,
    title: '盘点今年最出圈的五个网络热梗，你用过几个？',
    excerpt: '从年初到现在，网络热梗真是更新换代飞快。整理了一波今年出圈率最高的五个梗和它们的出处，看看哪个你还不知道。',
    author: '互联网考古家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20young%20explorer%20with%20magnifying%20glass%2C%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-kaogu&orientation=squarish',
    time: '3小时前',
    views: '2.3万',
    likes: 3201,
    comments: 762,
    category: '娱乐新瓜',
    hot: true,
  },
  {
    id: 6,
    title: '我家猫第一次听到打雷，反应也太可爱了',
    excerpt: '昨晚突然打雷，我家橘猫瞬间钻进沙发底下只露出半个头，眼神又怂又萌，笑到我满地找牙。附一张偷偷拍的图。',
    author: '铲屎官日常',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20girl%20holding%20a%20cat%2C%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-chan&orientation=squarish',
    time: '4小时前',
    views: '6040',
    likes: 1153,
    comments: 210,
    category: '萌宠日常',
    hot: false,
  },
  {
    id: 7,
    title: '热播新剧口碑两极，追之前先看完这篇再决定',
    excerpt: '最近这部新剧争议不小，有人说节奏太拖，有人说细节封神。我把前面几集看完了，说说真实观感，给大家排个雷。',
    author: '观剧指南针',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20young%20man%20with%20compass%2C%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-zhinan&orientation=squarish',
    time: '5小时前',
    views: '1.6万',
    likes: 2455,
    comments: 503,
    category: '热剧追更',
    hot: false,
  },
  {
    id: 8,
    title: '音乐节现场被求婚了！全场一起唱起那首歌',
    excerpt: '昨天的音乐节安可环节，台下一个男生单膝跪地掏出戒指，全场手机闪光灯一起亮起，主唱直接停了伴奏。浪漫死了。',
    author: '在现场',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20portrait%20of%20a%20crowd%20cheering%20at%20concert%2C%20warm%20flat%20illustration%20style%2C%20simple%20cream%20background&width=200&height=200&seq=avatar-zc&orientation=squarish',
    time: '6小时前',
    views: '4.8万',
    likes: 5302,
    comments: 1204,
    category: '音乐现场',
    hot: true,
  },
];

export const guideSteps: GuideItem[] = [
  { step: '01', title: '看看今天热榜', desc: '点开「今日热榜」和「最新投稿」，先感受下最近大家在追什么瓜、聊什么话题。', icon: 'ri-eye-2-line' },
  { step: '02', title: '找到感兴趣栏目', desc: '娱乐新瓜、热剧追更、综艺名场面……选一个你最有共鸣的栏目，刷起来更对味。', icon: 'ri-filter-3-line' },
  { step: '03', title: '发帖参与唠嗑', desc: '点右上角或页底的「我要投稿」，写下你想分享的新瓜或观点，几秒就能发出。', icon: 'ri-edit-2-line' },
  { step: '04', title: '追更互动不断线', desc: '帖子发布后记得回来追更进展、看评论互动，随时跟进最新动态不落伍。', icon: 'ri-chat-3-line' },
];

export const faqs: FaqItem[] = [
  { q: '投稿发帖需要注册账号吗？', a: '为了让大家能持续追更自己的帖子和互动记录，建议先创建一个账号。发帖、点赞、评论都绑定在你的账号上，瓜友也能找到你的主页。' },
  { q: '投稿的瓜或话题多久能被看到？', a: '提交后会进入快速审核队列，审核通过的内容会立即出现在对应栏目的最新投稿中，一般几分钟内就能被大家刷到。' },
  { q: '可以匿名投稿，只发内容不暴露身份吗？', a: '当然可以。你可以选择使用昵称发言，系统会保护你的个人信息，别人只能看到你设置的昵称和头像，不会泄露真实身份。' },
  { q: '投稿内容有什么需要注意的吗？', a: '请分享真实、积极、有趣的内容，避免造谣、人身攻击和泄露他人隐私。违反社区规范的内容会被下架，多次违规会影响账号发言权限。' },
  { q: '我看到一篇投稿有争议，该怎么处理？', a: '可以点击内容右下角的举报按钮提交理由，会有专人复核。你也可以在评论区理性表达自己的看法，和瓜友友好讨论。' },
  { q: '我的帖子火了之后想继续追更，怎么操作？', a: '你可以在自己发布的主页里继续补充进展、置顶更新，新回复会及时提醒你，方便你持续跟进话题的动态。' },
];

export const stats = [
  { value: '128万+', label: '累计投稿' },
  { value: '52万+', label: '活跃瓜友' },
  { value: '8600+', label: '每日话题' },
  { value: '98.7%', label: '瓜友好评率' },
];